import { components } from 'react-select';
import { Box, Avatar, Flex } from '@chakra-ui/react';

export const UserMultiValue = ({ children, data, ...props }) => {
  return (
    <components.MultiValueLabel {...props}>
      <Flex alignItems="center">
        <Avatar
          className="avatar-xs"
          name={data?.name}
          width="20px"
          height="20px"
          src={data?.avatar}
        />
        <Box as="span" display="inline-block" ml="sm">
          {children}
        </Box>
      </Flex>
    </components.MultiValueLabel>
  );
};
